<div class="fieldset title-area ">
  <legend>WorkBuddy</legend>
</div>

<div class="fieldset content-area">
  <div class="description description-title">Under maintenance</div>
  <div class="description">This organisation is currently under maintenance. Please try again later.</div>
</div>
